// bao migrate skip
import TabPage from "./../factories/tab-page";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import * as moment from "moment";
import TeamCalendarEditEntryDialog from "./dialogs/team-calendar-edit-entry-dialog";
import 'devextreme/integration/jquery';
import 'devextreme/ui/scheduler';
import baoShouter from "./../services/bao-shouter";
import MessageBus, { IMessageBusEventHandler } from "./../services/message-bus";
import Guid from "./../factories/guid";

export interface TeamCalendarViewData {
    infoId: string;
    reportId: string;
    ticketId: string;
    instructionId: string;
    text: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    type: string;
    color: string;
}
class TeamCalendarView extends BaseViewModel {
    TabPage: any;
    TeamCalendarHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    ShowCalendar: KnockoutObservable<boolean> = ko.observable(false);

    TeamCalendarVisibleRangeStart: KnockoutObservable<string> = ko.observable();
    TeamCalendarVisibleRangeEnd: KnockoutObservable<string> = ko.observable();

    TeamCalendarSelectedCells: KnockoutObservableArray<any> = ko.observableArray([]);
    TeamCalendarSelectedRangeStart: KnockoutObservable<Date> = ko.observable();
    TeamCalendarSelectedRangeEnd: KnockoutObservable<Date> = ko.observable();
    TeamCalendarSelectedIsAllDay: KnockoutObservable<boolean> = ko.observable();

    TeamCalendarViewData: KnockoutObservableArray<TeamCalendarViewData> = ko.observableArray([]);
    TeamCalendarViewHolidaysAndVacation: KnockoutObservableArray<TeamCalendarViewData> = ko.observableArray([]);
    Shiftbooks: KnockoutObservableArray<string> = ko.observableArray([]);

    TeamCalendarName: KnockoutObservable<string> = ko.observable();
    TeamCalendar: KnockoutObservable<any> = ko.observable();
    TeamCalendarHolidaysAndVacations: KnockoutObservable<any> = ko.observable();

    TeamCalendars: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedTeamCalendarId: KnockoutObservable<string> = ko.observable();
    SelectedTeamCalendarChanged: KnockoutObservable<boolean> = ko.observable(false);
    SelectedViewType: KnockoutObservable<any> = ko.observable();
    CurrentCalendar: any;
    CalendarHasChanges: KnockoutObservable<boolean>;
    TabPageIsActive: KnockoutObservable<boolean>;
    CalendarChangedMessage: KnockoutObservable<string>;

    InfoSavedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoSaved',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    InfoDeletedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoDeleted',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    InstructionSavedHandler: IMessageBusEventHandler = {
        name: 'notifyInstructionSaved',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    InstructionDeletedHandler: IMessageBusEventHandler = {
        name: 'notifyInstructionDeleted',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    TaskSavedHandler: IMessageBusEventHandler = {
        name: 'notifyTaskSaved',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    TaskDeletedHandler: IMessageBusEventHandler = {
        name: 'notifyTaskDeleted',
        handler: (result: { shiftbookIds: Array<string> }) => this.checkAndNotifyIfTeamCalendarExternalDataChanged(result.shiftbookIds)
    };
    TicketModifiedHandler: IMessageBusEventHandler = {
        name: 'notifyTicketModified',
        handler: (result: { teamcalendarId: string, actionId: string }) => this.checkAndNotifyIfTeamCalendarTicketDataChanged(result.teamcalendarId, result.actionId)
    };

    CurrentActionId: KnockoutObservable<any> = ko.observable();

    RoleTeamCalendar: KnockoutObservable<any> = ko.observable();

    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");

    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-success";
    Icon: string = "fal fa-calendar";
    Sort: number = 39;
    Name: KnockoutObservable<string> = ko.observable();
    ChangedViewOrDate: boolean;

    FirstDayOfWeek?: 0 | 1 | 2 | 3 | 4 | 5 | 6;


    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SettingsKeyPermission("TeamCalendarEdit");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.CalendarHasChanges = ko.observable(false);
        this.TabPageIsActive = this.TabPage.IsActiveTab;
        this.subscribe(this.SelectedTeamCalendarId, () => {
            if (this.loaded) {
                this.SelectedTeamCalendarChanged(true);
                this.TabPage.IsLoading(true);
                this.isQuickStartModuleActive().then(() => {
                    this.getTeamCalendarMetadata(false);
                    baoRouter.setHash("teamcalendarview/" + this.SelectedTeamCalendarId());
                }).always(() => this.TabPage.IsLoading(false));
            }
            this.SettingsUrl(this.SelectedTeamCalendarId() ? 'TeamCalendar/' + this.SelectedTeamCalendarId() : null);
        });
        this.RoleTeamCalendar.subscribe(() => {
            if (this.RoleTeamCalendar() && this.RoleTeamCalendar().HasPermissionEntryNew) {
                BaoMenu.permissionEnable({ ActionKey: "TeamCalendarViewNewEvent", Enabled: true, Context: this.TabPage.Context() });
            } else {
                BaoMenu.permissionEnable({ ActionKey: "TeamCalendarViewNewEvent", Enabled: false, Context: this.TabPage.Context() });
            }
        });
        this.subscribe(this.TabPage.UrlData, (value: any) => {
            if (value.teamcalendarid && this.SelectedTeamCalendarId() != value.teamcalendarid && this.TeamCalendars().some(b => ko.unwrap(b.TeamCalendarId) == value.teamcalendarid)) {
                this.SelectedTeamCalendarId(value.teamcalendarid)
            }
        });
    }

    registerEvents() {
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((value) => {
            if (this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case "TeamCalendarViewNewEvent":
                        this.openNewAppointmentDialog(this.TeamCalendarSelectedRangeStart(), this.TeamCalendarSelectedRangeEnd(), this.TeamCalendarSelectedIsAllDay());
                        break;
                    case "TeamCalendarViewRefresh":
                        this.RefreshCalendar();
                        break;
                    case "TeamCalendarViewSettings":
                        baoRouter.setHash("teamcalendar/" + this.SelectedTeamCalendarId());
                        break;
                }
            }
        }));
    }

    RefreshCalendar = () => {
        this.TabPage.IsLoading(true);
        this.getTeamCalendars()
            .then(_ => this.getTeamCalendarMetadata(true))
            .always(() => { this.TabPage.IsLoading(false); });
    }

    InitUrl() {
        return "";
    }

    init = () => {
        this.TabPage.IsLoading(true);
        BaoMenu.permissionEnable({ ActionKey: "TeamCalendarViewNewEvent", Enabled: false, Context: this.TabPage.Context() });
        return this.getTeamCalendars();
    }

    loaded = () => {
        let def = $.Deferred();
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        Bao.bindEvent('TeamCalendarFavorite:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this.registerTeamCalendarChangedHandler();
        this.CalendarChangedMessage = Bao.Session.GetMessage('msgTeamCalendarContentChanged');

        this.CalendarHasChanges.subscribe(function (hasChanges) {
            if (hasChanges && this.TabPageIsActive()) {
                baoShouter.show(this.CalendarChangedMessage(), 'warning', -1);
                this.CalendarHasChanges(false);
            }
        }.bind(this));

        this.TabPageIsActive.subscribe(function (isActive) {
            if (isActive && this.CalendarHasChanges()) {
                baoShouter.show(this.CalendarChangedMessage(), 'warning', -1);
                this.CalendarHasChanges(false);
            }
        }.bind(this));

        def.resolve();
        return def.promise();
    }

    getTeamCalendars = () => {
        return Bao.post('TeamCalendarView/GetTeamCalendarsForCurrentUser')
            .then(serverResult => {
                if (serverResult && serverResult.calendars && serverResult.calendars.length > 0) {
                    this.TeamCalendars(serverResult.calendars);
                } else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedTeamCalendars"), "info");
                    this.TabPage.IsLoading(false);
                    this.TabPage.$TabController.RemoveTab(this.TabPage);
                }
                let teamCalendarId = baoRouter.getRouteValue("teamcalendarid", (<any>this.TabPage));
                if (teamCalendarId && serverResult.calendars.filter(t => t.TeamCalendarId === teamCalendarId).length > 0) {
                    this.SelectedTeamCalendarId(teamCalendarId);
                } else if (!teamCalendarId && serverResult.calendars.length > 0) {
                    this.SelectedTeamCalendarId(serverResult.calendars[0].TeamCalendarId)
                }
            });
    }

    private getTeamCalendarMetadata(forceRefreshData: boolean) {
        if (!this.SelectedTeamCalendarId()) return $.Deferred().resolve().promise();
        return Bao.post("TeamCalendarView/GetTeamCalendarMetadata", JSON.stringify({
            teamCalendarId: this.SelectedTeamCalendarId()
        })).done(result => {
            this.TabPage.Title(result.TabTitle);
            this.FirstDayOfWeek = result.FirstDayOfWeek;
            if (result.IsTeamCalendarValid) {
                if (result.RoleTeamCalendar) {
                    this.TeamCalendar(result.TeamCalendar);
                    this.Shiftbooks(result.PermittedShiftbooks);
                    this.RoleTeamCalendar(result.RoleTeamCalendar);
                    this.GetTeamCalendarViewTypeFromUserProfile().then(type => {
                        this.SelectedViewType(type);
                        if (!forceRefreshData) {
                            this.TeamCalendarVisibleRangeStart(result.StartDay);
                            this.TeamCalendarVisibleRangeEnd(result.EndDay);
                            this.loadCalendar(result.CurrentTime, forceRefreshData);
                        }
                        else {
                            // Get the date between the start and the end of the current range
                            // This is necessary for the month view because the start/end date is often in a different month
                            let middleDateMillis = Math.round((new Date(this.TeamCalendarVisibleRangeStart()).getTime() + new Date(this.TeamCalendarVisibleRangeEnd()).getTime()) / 2);
                            this.loadCalendar(middleDateMillis, forceRefreshData);
                        }
                        this.ShowCalendar(true)
                    });
                } else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgTeamCalendarNotAssigned"), "info");
                    this.TabPage.IsLoading(false);
                }
            } else {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidTeamCalendar"), "info");
                this.TabPage.IsLoading(false);
            }
        });
    }

    private loadCalendar(currentTime: any, forceRefreshData: boolean) {
        let currentDateParsed = new Date(currentTime);
        return this.getHolidaysAndVacataions().done(() => {
            if (!$(this.TeamCalendarHTML()).data("dxScheduler")) {
                this.initCalendar(currentDateParsed, forceRefreshData);
            } else {
                // If a calendar is already initialized update only the necessary values
                return this.getTeamCalendarData(currentTime);
            }
        });
    }

    private getHolidaysAndVacataions() {
        return Bao.post("TeamCalendarView/GetHolidaysAndVacations", JSON.stringify({
            holidaySchemaId: this.TeamCalendar().HolidaySchemaId,
            fromDate: this.TeamCalendarVisibleRangeStart(),
            toDate: this.TeamCalendarVisibleRangeEnd()
        })).done((result) => {
            var data: TeamCalendarViewData[] = result.map(info => <TeamCalendarViewData>{
                startDate: info.StartDate,
                endDate: info.EndDate,
                text: info.Text,
                allDay: info.AllDay,
                type: info.Type,
                color: info.Color
            })
            this.TeamCalendarHolidaysAndVacations(data)
        });
    }

    private getTeamCalendarData(currentTime?) {
        this.TabPage.IsLoading(true);
        return Bao.post("TeamCalendarView/TeamCalendarData", JSON.stringify({
            fromDate: this.TeamCalendarVisibleRangeStart(),
            toDate: this.TeamCalendarVisibleRangeEnd(),
            shiftbooks: this.Shiftbooks(),
            teamcalendarId: this.SelectedTeamCalendarId()
        })).done(result => {
            var data: TeamCalendarViewData[] = result.map(info => <TeamCalendarViewData>{
                infoId: info.InfoId,
                reportId: info.ReportId,
                ticketId: info.TicketId,
                instructionId: info.InstructionId,
                startDate: info.StartDate,
                endDate: info.EndDate,
                text: info.Text,
                allDay: info.AllDay,
                type: info.Type,
                color: info.Color
            })
            var eventsWithHolidaysAndVacations = data.concat(this.TeamCalendarHolidaysAndVacations());
            var eventsWithHoliday = eventsWithHolidaysAndVacations.filter(day => day.type != "Vacation");
            this.TeamCalendarViewData(eventsWithHoliday);
            if (currentTime) {
                $(this.TeamCalendarHTML()).dxScheduler({
                    "dataSource": this.TeamCalendarViewData(),
                    currentView: this.SelectedViewType(),
                    currentDate: currentTime
                });
            } else {
                $(this.TeamCalendarHTML()).dxScheduler({
                    "dataSource": this.TeamCalendarViewData()
                });
                this.TabPage.IsLoading(false);
            }
        });
    }

    private initCalendar(currentDate: Date, forceRefreshData: boolean) {
        this.CurrentCalendar = $(this.TeamCalendarHTML()).dxScheduler({
            dataSource: this.TeamCalendarViewData(),
            views: ["month", "week", "day"],
            currentView: this.SelectedViewType(),
            crossScrollingEnabled: true,
            currentDate: currentDate,
            startDayHour: 0,
            endDayHour: 24,
            firstDayOfWeek: this.FirstDayOfWeek,
            height: window.innerHeight - 140,
            onOptionChanged: (e) => {
                let currValue = e.value;
                let prevValue = (e as any).previousValue ? (e as any).previousValue : currValue
                if (e.fullName == "currentView") {
                    this.TabPage.IsLoading(true);
                    this.SelectedViewType(e.value);
                    this.SetTeamCalendarViewTypeInUserProfile(e.value);
                    if (currValue != prevValue) {
                        this.ChangedViewOrDate = true;
                    }
                }
                if (e.fullName == "currentDate") {
                    this.TabPage.IsLoading(true);
                    currValue = new Date(currValue);
                    prevValue = new Date(prevValue);
                    if (currValue.toISOString().split('T')[0] != prevValue.toISOString().split('T')[0]){
                        this.ChangedViewOrDate = true;
                    }
                }
                if (e.name === "selectedCellData" && e.value.length > 0) {
                    this.TeamCalendarSelectedCells([...e.value]);
                    this.TeamCalendarSelectedIsAllDay(this.TeamCalendarSelectedCells()[0].allDay);
                    this.TeamCalendarSelectedRangeStart(this.TeamCalendarSelectedCells()[0].startDate);
                    this.TeamCalendarSelectedRangeEnd(
                        this.TeamCalendarSelectedIsAllDay() === true || this.TeamCalendarSelectedIsAllDay() === undefined ?
                        this.TeamCalendarSelectedCells()[this.TeamCalendarSelectedCells().length - 1].startDate :
                        this.TeamCalendarSelectedCells()[this.TeamCalendarSelectedCells().length - 1].endDate
                    );
                }
            },
            onContentReady: (e) => {
                if (this.ChangedViewOrDate) {
                    this.ChangedViewOrDate = false;
                    this.TabPage.IsLoading(true);
                    let timezoneOffset = e.component.getStartViewDate().getTimezoneOffset() * 60000 // in milliseconds
                    let rangeStart: string = new Date(e.component.getStartViewDate().getTime() - timezoneOffset).toISOString().split('.')[0]
                    let rangeEnd: string = new Date(e.component.getEndViewDate().getTime() - timezoneOffset).toISOString().split('.')[0]

                    // Remove the time part when comparing dates
                    if (rangeStart.split('T')[0] != this.TeamCalendarVisibleRangeStart().split('T')[0] || rangeEnd.split('T')[0] != this.TeamCalendarVisibleRangeEnd().split('T')[0]) {
                        this.TeamCalendarVisibleRangeStart(rangeStart);
                        this.TeamCalendarVisibleRangeEnd(rangeEnd);
                        if (!this.SelectedTeamCalendarChanged()) {
                            forceRefreshData = true;
                        } else {
                            this.SelectedTeamCalendarChanged(false);
                        }
                    }
                    if (forceRefreshData) {
                        this.getTeamCalendarData();
                    }
                }
                this.TabPage.IsLoading(false);
            },
            editing: {
                allowAdding: false,
                allowDragging: false,
                allowResizing: false,
                allowUpdating: false,
                allowDeleting: false
            },
            onAppointmentDblClick: (e) => {
                e.cancel = true;
            },
            onAppointmentFormOpening: (e) => {
                e.cancel = true;
            },
            appointmentTooltipTemplate: (data, index, element) => {
                return this.getDropdownAppointmentTemplate(data, element);
            },
            appointmentTemplate: (data) => {
                return this.getAppointmentTemplate(data);
            },
            onAppointmentClick: (e) => {
                if (e.appointmentData.type == "Holiday" || e.appointmentData.type == "Vacation") {
                    e.cancel = true
                }
                if ((<any>e.event.currentTarget).className == "dx-item dx-list-item dx-state-hover dx-state-focused") {
                    e.cancel = true;
                }
            },
            onAppointmentRendered: (e) => {
                this.renderAppointment(e);
            },
            dataCellTemplate: (cellData, index, container) => {
                $("<div>").text(cellData.text)
                    .toggleClass("weekend", this.isWeekEnd(cellData.startDate))
                    .toggleClass("vacation", this.IsVacation(cellData.startDate))
                    .toggleClass("holiday", this.IsHoliday(cellData.startDate))
                    .addClass("dx-template-wrapper")
                    .appendTo(container);
            },
            onInitialized: () => {
                this.getTeamCalendarData();
            }
        });
        window.addEventListener("resize", this.resizeEventHandler);        
    }

    private openNewAppointmentDialog(rangeStart: Date, rangeEnd: Date, isAllDay: boolean) {
        this.TabPage.IsLoading(true);
        Bao.post("TeamCalendarView/TeamCalendarEditEntryDialog")
            .done(result => {
                let dialog = new BaoDialog(Bao.Session.GetMessage("msgTeamCelendarAddEntryDialogTitle"), result.Template);
                dialog.Width("850px");
                let inputData = null;
                if (rangeStart && rangeEnd) {
                    inputData = {};
                    inputData["IsWholeDay"] = this.SelectedViewType() == "month" || isAllDay ? true : false;
                    inputData["FromDate"] = rangeStart;
                    inputData["ToDate"] = inputData["IsWholeDay"] ? this.calculateEndTimeForAllDay(rangeStart, rangeEnd) : rangeEnd;
                }
                dialog.ViewModel(new TeamCalendarEditEntryDialog(this, inputData));
                let viewModel = <TeamCalendarEditEntryDialog>dialog.ViewModel();
                dialog.Buttons([
                    new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                        if (viewModel.ItemCompleteCheck()) {
                            dialog.Close();
                            viewModel.adjustAllDayDates();
                            this.addNewEntry(viewModel);
                        }
                    }),
                    new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                        dialog.Close();
                    })
                ]);
                dialog.Open();
                dialog.CloseButtonClicked = () => {
                    dialog.Close();
                };
                this.TabPage.IsLoading(false);
            });
    }

    private calculateEndTimeForAllDay = (startDate, endDate) => {
        return moment(endDate).add(1, 'days').subtract(1, 'minutes').toDate();
    }

    private renderAppointment = (e) => {
        if (e.appointmentData.color) {
            e.appointmentElement[0].style.backgroundColor = e.appointmentData.color;
        }
    }

    private getAppointmentTemplate = (data: any) => {
        let icon = this.getAppointmentIcon(data);
        return $("<span>" + icon + " " + data.appointmentData.text + "</span>");
    }

    private getAppointmentIcon = (data: any) => {
        let icon = "";
        switch (data.appointmentData.type) {
            case "Info":
                icon = '<i class="fal fa-dot-circle"></i>';
                break;
            case "Instruction":
                icon = '<i class="fal fa-exclamation-triangle"></i>';
                break;
            case "Task":
                icon = '<i class="fal fa-calendar-check"></i>';
                break;
        }
        return icon;
    }

    private getDropdownAppointmentTemplate = (data: any, element: any) => {
        element.append($("" +
            "<div class='dx-scheduler-dropdown-appointment-title' style='max-width:200px;'>" + this.getAppointmentIcon(data) + " " + data.appointmentData.text + "</div>" +
            "<div class='dx-scheduler-dropdown-appointment-date'>" + moment(data.appointmentData.startDate).format(Bao.Utils.DateTimeDisplayFormat) + ' - ' + moment(data.appointmentData.endDate).format(Bao.Utils.DateTimeDisplayFormat) + "</div>" +
            "<div class='dropdown-appointment-buttons-block' style='margin-top:5px;'>" +
            "<div class='edit' style='margin-right:5px;'></div>" +
            "<div class='delete'></div>" +
            "</div>")).click(e => {
                e.stopPropagation();
            });
        if ((data.appointmentData.type == "Ticket" && this.RoleTeamCalendar().HasPermissionEntryEdit) || (data.appointmentData.type != "Ticket" && this.RoleTeamCalendar().HasPermissionEntryOpen)) {
            element.find(".edit").dxButton({
                icon: "edit",
                onClick: () => {
                    this.editAppointment(data);
                }
            });
        }
        if (data.appointmentData.type == "Ticket" && this.RoleTeamCalendar().HasPermissionEntryDelete) {
            element.find(".delete").dxButton({
                icon: "trash",
                onClick: () => {
                    this.deleteAppointment(data);
                }
            });
        }
    }

    private deleteAppointment = (data) => {
        this.TabPage.IsLoading(true);
        var dialog = new BaoDialog(Bao.Session.GetMessage("msgTeamCelendarDeleteEntryDialogTitle"), Bao.Session.GetMessage("msgTeamCelendarDeleteEntryDialogMessage"), "yesno");
        dialog.DialogResult.subscribe(result => {
            if (result === true && data.appointmentData.type === "Ticket") {
                this.deleteEntry(data.appointmentData);
                dialog.Close();
            }
        });
        this.TabPage.IsLoading(false);
    }

    private editAppointment = (data: any) => {
        switch (data.appointmentData.type) {
            case "Whiteboard":
                baoRouter.setHash("whiteboard/" + data.appointmentData.instructionId);
                break;
            case "Task":
                baoRouter.setHash("task/" + data.appointmentData.instructionId);
                break;
            case "Instruction":
                baoRouter.setHash("instruction/" + data.appointmentData.instructionId);
                break;
            case "Info":
                //Get the latest possible event
                Bao.post("TeamCalendarView/GetNewestPossibleReportIdForTeamCalendarToOpenInfo", JSON.stringify({
                    startDate: null,
                    endDate: null,
                    infoid: data.appointmentData.infoId
                })).done((result) => {
                    baoRouter.setHash("report/" + result + "/info/" + data.appointmentData.infoId);
                })
                break;
            case "Ticket":
                this.TabPage.IsLoading(true);
                Bao.post("TeamCalendarView/GetEntry", JSON.stringify({
                    tickedId: data.appointmentData.ticketId
                })).done(result => {
                    Bao.post("TeamCalendarView/TeamCalendarEditEntryDialog").done(resultDialog => {
                        let dialog = new BaoDialog(Bao.Session.GetMessage("msgTeamCelendarEditEntryDialogTitle"), resultDialog.Template);
                        dialog.Width("850px");
                        dialog.ViewModel(new TeamCalendarEditEntryDialog(this, result));
                        let viewModel = <TeamCalendarEditEntryDialog>dialog.ViewModel();
                        dialog.Buttons([
                            new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                                if (viewModel.ItemCompleteCheck()) {
                                    dialog.Close();
                                    viewModel.adjustAllDayDates();
                                    this.editEntry(data.appointmentData.ticketId, viewModel);
                                }
                            }),
                            new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                                dialog.Close();
                            })
                        ]);
                        dialog.Open();
                        dialog.CloseButtonClicked = () => {
                            dialog.Close();
                        };
                        this.TabPage.IsLoading(false);
                    });
                })
                break;
            default:
        }
    }


    private resizeEventHandler = (e) => {
        $(this.TeamCalendarHTML()).dxScheduler({
            height: window.innerHeight - 140,
        });
    }

    private addNewEntry(newEntry) {
        this.TabPage.IsLoading(true);
        this.CurrentActionId(Guid());
        return Bao.post("TeamCalendarView/AddNewEntry", JSON.stringify({
            teamCalendarId: this.SelectedTeamCalendarId(),
            name: newEntry.Name(),
            description: newEntry.Description(),
            location: newEntry.Location(),
            fromDate: newEntry.FromDateJs(),
            toDate: newEntry.ToDateJs(),
            isWholeDay: newEntry.IsWholeDay(),
            actionId: this.CurrentActionId()
        })).done(result => {
            this.getTeamCalendarData();
        });
    }

    private editEntry(ticketId, entry) {
        this.TabPage.IsLoading(true);
        this.CurrentActionId(Guid());
        return Bao.post("TeamCalendarView/EditEntry", JSON.stringify({
            teamCalendarId: this.SelectedTeamCalendarId(),
            name: entry.Name(),
            description: entry.Description(),
            location: entry.Location(),
            fromDate: entry.FromDateJs(),
            toDate: entry.ToDateJs(),
            isWholeDay: entry.IsWholeDay(),
            ticketId: ticketId,
            actionId: this.CurrentActionId()
        })).done(result => {
            this.getTeamCalendarData();
        });

    }

    private deleteEntry(entry) {
        this.TabPage.IsLoading(true);
        this.CurrentActionId(Guid());
        return Bao.post("TeamCalendarView/DeleteEntry", JSON.stringify({
            id: entry.ticketId,
            teamcalendarId: this.SelectedTeamCalendarId(),
            actionId: this.CurrentActionId()
        })).done(result => {
            this.getTeamCalendarData();
        });
    }

    private isWeekEnd(date) {
        var day = date.getDay();
        return day === 6 || day === 0;
    }
    private IsHoliday(date: Date) {
        var formattedDate = moment(date).format(Bao.Utils.DateFormat);
        return this.TeamCalendarHolidaysAndVacations().some(teamCalendarData => moment(teamCalendarData.startDate).format(Bao.Utils.DateFormat) === formattedDate && teamCalendarData.type === "Holiday")
    }

    private IsVacation(date: Date) {
        var formattedDate = moment(date).format(Bao.Utils.DateFormat);
        return this.TeamCalendarHolidaysAndVacations().some(teamCalendarData => moment(teamCalendarData.startDate).format(Bao.Utils.DateFormat) === formattedDate && teamCalendarData.type === "Vacation")
    }


    //Favorites
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        } else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    }

    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: this.TeamCalendar().Name,
            caption2: this.TeamCalendar().Name,
            caption3: this.TeamCalendar().Name,
            caption4: this.TeamCalendar().Name,
            caption5: this.TeamCalendar().Name,
            webUrl: this.GetTeamCalendarViewDeepLink(),
            color: this.Color,
            icon: this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                Bao.raiseEvent('TeamCalendarFavorite:refresh', {});
            }
            this.TabPage.IsLoading(false);
        });
    }

    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetTeamCalendarViewDeepLink()
        })).done(result => {
            if (result) {
                Bao.raiseEvent('TeamCalendarFavorite:refresh', {});
            }
            this.TabPage.IsLoading(false);
        });
    }

    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetTeamCalendarViewDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    }

    GetTeamCalendarViewDeepLink() {
        return "#/teamcalendarview/" + this.SelectedTeamCalendarId();
    }

    // override to avoid this.unlockurl-call
    BeforeClose(closeFn) {
        // Remove EventListeners and event bindings
        window.removeEventListener('scroll', this.resizeEventHandler);
        MessageBus.unsubscribe([
            this.InfoSavedHandler,
            this.InfoDeletedHandler,
            this.InstructionSavedHandler,
            this.InstructionDeletedHandler,
            this.TaskSavedHandler,
            this.TaskDeletedHandler,
            this.TicketModifiedHandler
        ]);
        // call closeFn(callback) to accept the close and close it
        closeFn();
        return $.Deferred().resolve();
    }

    CompleteCheck() {
        return true;
    }

    SetTeamCalendarViewTypeInUserProfile(type) {
        return Bao.post("TeamCalendarView/SetTeamCalendarViewTypeInUserProfile", JSON.stringify({
            calendarId: ko.unwrap(this.TeamCalendar().TeamCalendarId),
            type: type
        }));
    }

    GetTeamCalendarViewTypeFromUserProfile() {
        this.TabPage.IsLoading(true);
        return Bao.post("TeamCalendarView/GetTeamCalendarViewTypeFromUserProfile", JSON.stringify({
            calendarId: ko.unwrap(this.TeamCalendar().TeamCalendarId)
        })).then((data) => {
            let result;
            try {
                result = JSON.parse(data);
            } catch {
                result = data;
            }
            return result;
        }
        ).always(_ => {
            this.TabPage.IsLoading(false);
        });
    }

    /**
     * Check if a given ShiftbookId is relevant to the current Team Calendar
     * @param ids
     */
    protected checkAndNotifyIfTeamCalendarExternalDataChanged = (ids: Array<string>) => {
        //Do not notify multiple times
        if (this.CalendarHasChanges()) {
            return;
        }
        if (ids.some(id => this.Shiftbooks().includes(id))) {
            this.CalendarHasChanges(true);
        }
    }

    /**
     * Check if a given Team Calendar Ticket modified event is relevant to the current Team Calendar
     * @param id
     */
    protected checkAndNotifyIfTeamCalendarTicketDataChanged = (teamcalendarId: string, actionId: string) => {
        //Do not notify multiple times
        if (this.CalendarHasChanges()) {
            return;
        }
        if (teamcalendarId === this.SelectedTeamCalendarId() && actionId != this.CurrentActionId()) {
            this.CalendarHasChanges(true);
        }
    }
    /**
     * Register handlers
     */
    protected registerTeamCalendarChangedHandler = () => {
        MessageBus.subscribe([
            this.InfoSavedHandler,
            this.InfoDeletedHandler,
            this.InstructionSavedHandler,
            this.InstructionDeletedHandler,
            this.TaskSavedHandler,
            this.TaskDeletedHandler,
            this.TicketModifiedHandler
        ]).catch(() => {
            console.warn('Cannot connect to MessageBus');
        });
    }
}
export default TeamCalendarView;